/* uspl.js
 * Purpose:
 * - Drives Custom Upholstery swatches (existing behavior), but cleaned up + deduped
 * - Adds Wood Seat swatches driven by product metafield: custom.wood_seat_colors
 *   Example metafield value: "Wooden Seat, Natural, Walnut, Espresso, Mahogany, Oak"
 *
 * Assumptions about markup (matches what you showed):
 * Custom upholstery:
 *  - .custom-color-option-main
 *  - .custom-color-li input[title="..."]
 *  - .option-name-val[data-id="{Seat Option label}"]  (e.g. "Custom Upholstery Padded Seat")
 *  - .custom-color-data-change[data-id="{Seat Option label}"] with .custom-color-var and span.inner
 *  - #custom-color-line-item (hidden input that gets proper name/value)
 *
 * Wood seat:
 *  - .wood-seat-color-option-main
 *  - .wood-seat-color-li input[title="Natural"] etc
 *  - .wood-seat-option-name-val[data-id="Wooden Seat"] (or whatever exact Seat Option label is)
 *  - .wood-seat-color-data-change[data-id="Wooden Seat"] with .wood-seat-color-var and span.inner
 *  - input[data-wood-seat-finish-prop] (hidden line-item property)
 */

$(document).ready(function () {
  // =========================
  // Helpers
  // =========================
  function safeText(s) {
    return (s || "").toString();
  }

  // Their data-id matching breaks if we don’t strip apostrophes consistently (they do replace("'", ""))
  function stripApostrophes(s) {
    return safeText(s).replace(/'/g, "");
  }

  function getSelectedSeatOptionTextFromBV() {
    // BV "Seat Option" click handler passes the text in the span.text.
    // Here we just return null; the click handler supplies it.
    return null;
  }

  function getSelectedSeatOptionTextFromSelect() {
    // This select seems to reflect seat option state in your theme.
    // (You already rely on .product-single__variant-select)
    var v = $(".product-single__variant-select option:selected").val();
    return v ? safeText(v) : "";
  }

  function isCustomUpholsterySeat(seatLabelRaw) {
    var t = safeText(seatLabelRaw).toLowerCase();
    return t.indexOf("custom upholstery") >= 0;
  }

  function isWoodenSeat(seatLabelRaw) {
    var t = safeText(seatLabelRaw).toLowerCase();
    return t === "wooden seat" || t.indexOf("wooden seat") >= 0 || t.indexOf("wood seat") >= 0;
  }

  // =========================
  // Custom Upholstery UI
  // =========================
  function hideCustomUpholsteryUI() {
    $(".custom-color-option-main").find(".option-name-val").hide();
    $(".custom-color-option-main").find(".custom-color-data-change").hide();

    // Clear + disable line item field
    $("#custom-color-line-item").val("");
    $("#custom-color-line-item").attr("name", "properties[]");
    $("#custom-color-line-item").attr("disabled", "disabled");
    $(".line-item-property__field").find("label").text("");
  }

  function setCustomUpholsteryLineItemName(seatLabelOriginal) {
    // seatLabelOriginal might contain apostrophes; they try to handle it.
    if (!seatLabelOriginal) {
      $("#custom-color-line-item").attr("name", "properties[]");
      return;
    }

    // Keep original label in properties[...] for quoting / request forms
    // Their old code did:
    //   if (label contains "'") set name='properties['+label+']'
    //   then set name="properties["+label+"]"
    // Which is redundant; we just do it once.
    $("#custom-color-line-item").attr("name", "properties[" + seatLabelOriginal + "]");
  }

  function selectFirstCustomUpholsterySwatch($context) {
    var $first = $context.find(".custom-color-li input").first();
    if ($first.length) {
      $first.prop("checked", true);
      // Trigger click to reuse their existing logic that reads title
      $first.trigger("click");
    }
  }

  function updateCustomUpholsteryUI(seatLabelOriginal, seatLabelForDataId) {
    // Show correct option group
    $(".custom-color-option-main").find(".option-name-val").hide();
    $(".custom-color-option-main").find('.option-name-val[data-id="' + seatLabelForDataId + '"]').show();

    // Toggle the little label row (custom-color-data-change)
    $(".custom-color-option-main").find(".custom-color-data-change").hide();
    $(".custom-color-option-main")
      .find('.custom-color-data-change[data-id="' + seatLabelForDataId + '"]')
      .show()
      .find(".custom-color-var")
      .text(seatLabelOriginal + ":");

    // If visible, ensure we have a selected swatch and set label/input
    if ($(".custom-color-li").is(":visible")) {
      var $wrap = $(".custom-color-option-main").find('.option-name-val[data-id="' + seatLabelForDataId + '"]');
      selectFirstCustomUpholsterySwatch($wrap);

      var cc_val = $(".custom-color-li").find("input:checked").attr("title") || "";
      $(".custom-color-option-main").find("span.inner").text(cc_val);

      setCustomUpholsteryLineItemName(seatLabelOriginal);
      $("#custom-color-line-item").val(cc_val);
      $("#custom-color-line-item").removeAttr("disabled");

      $(".line-item-property__field").find("label").text(seatLabelOriginal + ":");
    } else {
      hideCustomUpholsteryUI();
    }
  }

  // Keep their hover preview behavior
  $(".custom-color-li").hover(
    function () {
      var cc_val = $(this).find("input").attr("title");
      $(this).parents(".custom-color-option-main").find("span.inner").text(cc_val);
    },
    function () {
      var cc_val = $(".custom-color-li").find("input:checked").attr("title");
      $(this).parents(".custom-color-option-main").find("span.inner").text(cc_val);
    }
  );

  // When a custom swatch changes, update label + hidden line item value
  $(document).on("change", ".custom-color-li input", function () {
    var cc_val = $(this).attr("title") || "";
    $(this).parents(".custom-color-option-main").find("span.inner").text(cc_val);
    $("#custom-color-line-item").val(cc_val);
  });

  // =========================
  // Wood Seat UI
  // =========================
  function hideWoodSeatUI() {
    $(".wood-seat-color-option-main").find(".wood-seat-option-name-val").hide();
    $(".wood-seat-color-option-main").find(".wood-seat-color-data-change").hide();
    $('[data-wood-seat-finish-prop]').val("");
  }

  function selectFirstWoodSeatSwatch($context) {
    var $first = $context.find(".wood-seat-color-li input").first();
    if ($first.length) {
      $first.prop("checked", true);
      $first.trigger("change");
    }
  }

  function updateWoodSeatUI(seatLabelOriginal, seatLabelForDataId) {
    // Show correct option group
    $(".wood-seat-color-option-main").find(".wood-seat-option-name-val").hide();
    $(".wood-seat-color-option-main").find('.wood-seat-option-name-val[data-id="' + seatLabelForDataId + '"]').show();

    // Toggle label row
    $(".wood-seat-color-option-main").find(".wood-seat-color-data-change").hide();
    $(".wood-seat-color-option-main")
      .find('.wood-seat-color-data-change[data-id="' + seatLabelForDataId + '"]')
      .show()
      .find(".wood-seat-color-var")
      .text("Wood Seat Finish");

    // If visible, default select and set property value
    var $wrap = $(".wood-seat-color-option-main").find('.wood-seat-option-name-val[data-id="' + seatLabelForDataId + '"]');
    if ($wrap.is(":visible") && $wrap.find(".wood-seat-color-li").length) {
      selectFirstWoodSeatSwatch($wrap);

      var ws_val = $wrap.find(".wood-seat-color-li input:checked").attr("title") || "";
      $(".wood-seat-color-option-main").find("span.inner").text(ws_val);
      $('[data-wood-seat-finish-prop]').val(ws_val);
    } else {
      hideWoodSeatUI();
    }
  }

  // When wood swatch changes, set display + hidden property
  $(document).on("change", ".wood-seat-color-li input", function () {
    var ws_val = $(this).attr("title") || "";
    $(this).parents(".wood-seat-color-option-main").find("span.inner").text(ws_val);
    $('[data-wood-seat-finish-prop]').val(ws_val);
  });

  // Optional hover preview (matches upholstery)
  $(".wood-seat-color-option-main").on("mouseenter", ".wood-seat-color-li", function () {
    var ws_val = $(this).find("input").attr("title") || "";
    $(this).parents(".wood-seat-color-option-main").find("span.inner").text(ws_val);
  });
  $(".wood-seat-color-option-main").on("mouseleave", function () {
    var ws_val = $(".wood-seat-color-li").find("input:checked").attr("title") || "";
    $(this).find("span.inner").text(ws_val);
  });

  // =========================
  // Seat Option Router (mutual exclusivity)
  // =========================
  function updateSeatDependentUIs(seatLabelOriginalRaw) {
    var seatLabelOriginal = safeText(seatLabelOriginalRaw);
    var seatLabelForDataId = stripApostrophes(seatLabelOriginal);

    // Rules:
    // - If Custom Upholstery: show upholstery swatches; hide wood seat swatches
    // - If Wooden Seat: show wood seat swatches; hide upholstery swatches
    // - Else: hide both
    if (isCustomUpholsterySeat(seatLabelOriginal)) {
      hideWoodSeatUI();

      // Upholstery block was historically delayed 500ms after BV click, keep that to match DOM updates
      setTimeout(function () {
        updateCustomUpholsteryUI(seatLabelOriginal, seatLabelForDataId);
      }, 500);
      return;
    }

    if (isWoodenSeat(seatLabelOriginal)) {
      hideCustomUpholsteryUI();

      // Wood seat block also needs a delay because BV / select UI updates are async
      setTimeout(function () {
        // IMPORTANT: your wood-seat Liquid uses data-id="Wooden Seat"
        // If your seat option label differs (e.g. "Wood Seat"), change this mapping.
        updateWoodSeatUI("Wooden Seat", "Wooden Seat");
      }, 500);
      return;
    }

    // Everything else
    hideCustomUpholsteryUI();
    hideWoodSeatUI();
  }

  // =========================
  // Initial boot (page load)
  // =========================
  (function init() {
    // They used optVal0/optVal; we only need the selected label
    var selected = getSelectedSeatOptionTextFromSelect();
    if (!selected) {
      // If select doesn't exist, just hide everything
      hideCustomUpholsteryUI();
      hideWoodSeatUI();
      return;
    }

    // On load, if upholstery exists, default-select first swatch for that seat option
    // and show correct block.
    updateSeatDependentUIs(selected);
  })();

  // =========================
  // Event wiring (matches your existing behavior)
  // =========================

  // BV “Seat Option” UI click
  $(document).on("click", ".bv_ul_inner  span.li", function () {
    var vtxt0 = $(this).find("span.text").text(); // original (keep apostrophes)
    updateSeatDependentUIs(vtxt0);
  });

  // Select-based fallback
  $(document).on("change", ".product-single__variant-select", function () {
    var vtxt = $(this).val();
    updateSeatDependentUIs(vtxt);
  });

  // $(document).on('change', '.f8pr-variant-selection ul li input', function(){
  //   var cc_val =   $(this).attr("title")
  //   //console.log(cc_val);
  //   var ccc_val =  $(".product-single__variant-select").find("option:selected").val();
  //   // console.log(ccc_val);
  //   var cc_val_final = cc_val+" / "+ccc_val;
  //   console.log(cc_val_final);
  //   $('.product-all__variant-select option:selected').removeAttr('selected');
    
  //    $(this).parents(".f8pr-variant-selection").find("select.product-all__variant-select option[data-value='"+cc_val_final+"']").trigger('click');
  //   $(this).parents(".f8pr-variant-selection").find("select.product-all__variant-select option[data-value='"+cc_val_final+"']").attr('selected','selected');
      
 
  // });

////////////////in app replace seat cover property /////////////////////
// window.addEventListener('load', function() {
// var myInterval = setInterval(ppTracking, 1000);
//   function ppTracking() { 
//    if($('.omgrfq-popup').is(':visible')){
//      var length =  $('.omgrfq-popup').length;

//       if (length => 1) {
//         $("tr.omgrfq_product_row").each(function(){
//          if($(".omgrfq_product_title-wrapper div p").length != 0)
//             {
//             var total = $(".omgrfq_product_title-wrapper div").find("p").text();
//             tota = total.split(" ");
//               console.log(tota);
//             tot = tota.split(":");
//               $(this).find(".omgrfq_product_title-wrapper div").find("p").html("<span class='frcp-total-label' style='display:none;'>"+total[0]+"</span><span class='frcp-total-count' style='display:none;'>"+total[1]+"</span>");
//                 console.log(""+total[1]);
//               //$(this).find(".omgrfq_product_title-wrapper div").find("p").text(total[1]);
//               //tota = total.replace("Sheat Cover", " ");
//                //console.log("t"+tota);
//              // $(".omgrfq_product_title-wrapper div").find("p").text(tota);
//             //$(this).find("p").html("<span class='frcp-total-label'>"+total[0]+"</span><span class='frcp-total-count'>"+total[1]+"</span>");
//             }
//         });
//        clearInterval(myInterval);
//       }
//     }
//   } 
// });
  

});